import React from 'react';
import { Person } from 'nekst-api';
import usePeopleNavigator from '../peopleNavigator';
import { Button, ButtonColor, ButtonSize } from 'ui-builder';

export default function OpenShowProfilePageButton(
  props: {
    person: Person,
  },
) {
  const peopleNavigator = usePeopleNavigator();
  return (
    <Button
      text="Profile"
      onClick={async () => peopleNavigator.openViewPersonPage(props.person.id)}
      color={ButtonColor.BLUE}
      isFilled
      size={ButtonSize.MEDIUM}
    />
  );
}
